/**
 * General CMS configuration
 *
 * @type {{baseUrl: string}}
 */
const logo = require('../images/CardioCast-Logo-OneClrWhite_R_130x30.png')

module.exports = {
    base: require('./base-config'),

    header: {
        title: 'CardioCast',
        logo: [logo],
        homepage: '/#/',
        buttons: [
            {
                iconName: 'user',
                children: {
                    items: [
                        {
                            item: 'User Profile',
                            href: '/#/instructors/me',
                            permissions: ['instructor'],
                            iconName: 'user'
                        }
                    ]
                }
            }
        ]
    },

    navbar: [
        {
            "buttonName": "Manage App",
            "href": "",
            "permissions": ['admin'],
            "children": [
                {
                    "buttonName": "Instructors",
                    "href": "#/instructors"
                },
                {
                    "buttonName": "Subscribers",
                    "href": "#/subscribers"
                },
                {
                    "buttonName": "Subscriptions",
                    "href": "#/subscriptions"
                },
                {
                    "buttonName": "Menu URLs",
                    "href": "#/menu-urls"
                },
                {
                    "buttonName": "Legal Disclaimer",
                    "href": "#/legal-disclaimer"
                },
                {
                    "buttonName": "Codes Generation",
                    "href": "#/codes"
                },
            ]
        },
        {
            "buttonName": "Casts",
            "href": "#/cast-library",
            "permissions": ['admin']
        },
        {
            "buttonName": "Messages",
            "href": "",
            "permissions": ['admin'],
            "children": [
                {
                    "buttonName": "Email Messages",
                    "href": "#/email-messages"
                },
                {
                    "buttonName": "Push Messages",
                    "href": "#/push-messages"
                }
            ]
        },
        {
            "buttonName": "Music",
            "href": "",
            "permissions": ['admin'],
            "children": [
                {
                    "buttonName": "Music Library",
                    "href": "#/music-library"
                },
                {
                    "buttonName": "Genres",
                    "href": "#/genres"
                },
                {
                    "buttonName": "Movements",
                    "href": "#/movements"
                },
                {
                    "buttonName": "Song Play Reports",
                    "href": "#/reports/song-plays"
                }
            ]
        },
        {
            "buttonName": "Workouts",
            "href": "#/workouts",
            "permissions": ['admin']
        },
    ]
};
